/* ───────────────────────────────────────────────────────────
   Leeftijdscheck + laadscherm
   (snippets/klaasje-intro.liquid, de opmaak in klaasje-intro.css)

   Clean gehouden: het verloop op de achtergrond golft rustig, en na een
   geldige datum doet het logo de kleurwissel van de live site.

   - Golf. Het ribbon field (navy naar lichte navy, met een naad die als
     een S door het beeld loopt) beweegt langzaam: de S schuift langs de
     linten en ademt een fractie mee, alsof er een deining doorheen gaat.
     Een kleine WebGL-shader op __wave; zie 2.
   - Bij enter komt de golf op: het licht op de kam en de diepte komen er
     in, en de golf zwelt langzaam een fractie aan. De vorm verspringt niet.
     Zo rolt hij door tot het vlak vervaagt.
   - Na enter vervaagt het formulier en glijdt het logo naar het midden.
     Daar springt het rood, groen, geel, en dat blijft ronddraaien zolang de
     hero zijn eerste stuk frames nog niet heeft (met MAX_WAIT_MS als
     plafond). Dat is de laadindicatie.
   - Dan vervaagt het vlak en staat de site er, terwijl het logo in zijn
     plek in de header glijdt en de kleur van het header-logo aanneemt: op
     de homepage wit (spookstand), elders navy.
   Bij prefers-reduced-motion beweegt er niets: het verloop staat stil en
   na een geldige datum vervaagt het scherm meteen.

   Het inline script in layout/theme.liquid zet `klaasje-intro-open` op
   <html> zolang de sessionStorage-vlag ontbreekt. Alleen dan doet dit
   script iets.
   ─────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var html = document.documentElement;
  var root = document.querySelector('[data-klaasje-intro]');
  if (!root || !html.classList.contains('klaasje-intro-open')) return;

  /* Zelfde sleutel als live, zodat wie daar al door de check is niet
     opnieuw hoeft zodra de winkel op hetzelfde domein draait. */
  var FLAG = 'klaasje_intro_done';

  /* Standaarden; elk is te overschrijven met een data-attribuut op het
     vlak (zie het snippet). */
  function num(name, fallback) {
    var value = parseFloat(root.getAttribute('data-' + name));
    return isFinite(value) ? value : fallback;
  }
  /* Welk deel van de frames er vanaf frame 1 aaneengesloten moet zijn. De
     kop gaat weg op 25 tot 35% van het frame-deel, dus een vijfde is ruim
     genoeg om weg te scrollen zonder tegen een gat aan te lopen; de rest
     laadt mee terwijl je scrolt. */
  var LEAD = num('lead', 0.2);
  /* Hoe lang het vlak ná een geldige datum hooguit op de frames wacht. */
  var MAX_WAIT_MS = num('max-wait', 6000);
  /* De golf, twee standen: vóór enter (de gate) en na enter. Elk met een
     golflengte en hoogte (keer die van het snippet), een tempo (keer het
     gewone) en hoe ver de naad heen en weer deint (in procenten van het
     verloop). Na enter komen er licht op de kam en diepte bij (0 tot 1+).
     Tussen de twee standen loopt een zachte ease-in-out: de vorm in
     SHAPE_MS, het licht in LIGHT_MS. Let op: een vorm die snel verandert
     (vooral de golflengte) leest als uitrekken, en hoogte gedeeld door
     golflengte boven ~1,2 laat de naad tot strepen vouwen. */
  var WAVE_LENGTH = Math.max(0.2, num('wave-length', 2.65));
  var WAVE_HEIGHT = num('wave-height', 2.1);
  var WAVE_SPEED = num('wave-speed', 1.45);
  var WAVE_SWAY = num('wave-sway', 2);
  var SWELL_LENGTH = Math.max(0.2, num('swell-length', 0.85));
  var SWELL_HEIGHT = num('swell-height', 0.85);
  var SWELL_SPEED = num('swell-speed', 4);
  var SWELL_SWAY = num('swell-sway', 5.1);
  var SHEEN = num('sheen', 0.45);
  var DEPTH = num('depth', 1.6);
  var SHAPE_MS = Math.max(50, num('shape-ms', 3650));
  var LIGHT_MS = Math.max(50, num('light-ms', 550));
  var WAVE_FROM_ENTER = root.getAttribute('data-wave-from') === 'enter';
  /* De kleurwissel begint als het logo in het midden staat (de glijtijd in
     de CSS) en elke kleur staat COLOR_STEP_MS. Het vlak vervaagt op zijn
     vroegst FADE_AT_MS na enter, in FADE_MS. */
  var COLOR_AT_MS = num('color-at', 450);
  var COLOR_STEP_MS = num('color-step', 200);
  var FADE_AT_MS = num('fade-at', 1000);
  var FADE_MS = num('fade-ms', 600);
  var FLIGHT = root.getAttribute('data-flight') !== 'off';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var sheet = root.querySelector('[data-klaasje-intro-sheet]');
  var logoEl = root.querySelector('[data-klaasje-intro-logo]');
  var form = root.querySelector('[data-klaasje-intro-form]');
  var fields = root.querySelector('[data-klaasje-intro-fields]');
  var dayEl = root.querySelector('[data-klaasje-intro-day]');
  var monthEl = root.querySelector('[data-klaasje-intro-month]');
  var yearEl = root.querySelector('[data-klaasje-intro-year]');
  var errorEl = root.querySelector('[data-klaasje-intro-error]');
  if (!form || !dayEl || !monthEl || !yearEl) return;

  /* Alles achter het vlak is onbereikbaar voor toetsenbord en schermlezer
     zolang het er staat. We onthouden wat we zelf op inert zetten, zodat
     we bij het afsluiten niets losmaken dat al inert was. */
  var inerted = [];
  Array.prototype.forEach.call(document.body.children, function (el) {
    if (el === root || el.tagName === 'SCRIPT' || el.inert) return;
    el.inert = true;
    inerted.push(el);
  });

  /* ── De balken van Safari ────────────────────────────────────
     Safari 26 kleurt zijn balk bovenin en onderin naar wat er tegen die
     rand ligt, en kijkt pas opnieuw als het vaste element dat het daar
     vond uit de pagina gaat. Twee schermopnames van de eigenaar (15 en 16
     oktober) lieten het zien: een kleurwissel op het vlak, de hit-test
     loslaten en zelfs strookjes die tijdens het vervagen zes keer werden
     vervangen, niets daarvan veranderde de balken; ze sprongen pas om toen
     het vlak weg was, 0,6 s nadat de site er al stond. Daarom gaat het
     vaste vlak bij het begin van het vervagen meteen uit de pagina (zie
     maakLos), en vervaagt een kopie die niet `fixed` is.
     De strookjes hieronder zijn er alleen voor de leeftijdscheck zelf. */
  var randen = { boven: null, onder: null };

  function maakRand(kant, kleur) {
    var el = document.createElement('div');
    el.className = 'klaasje-intro__rand klaasje-intro__rand--' + kant;
    el.setAttribute('aria-hidden', 'true');
    el.style.backgroundColor = kleur;
    root.appendChild(el);
    randen[kant] = el;
  }

  var randKleur = getComputedStyle(sheet).backgroundColor || 'rgb(67, 123, 157)';
  maakRand('boven', randKleur);
  maakRand('onder', randKleur);

  /* Vervangt het vlak door een kopie zonder `position: fixed` (.is-los,
     staat op de bovenkant van de pagina, die net naar boven gescrold is) en
     verhuist de inhoud erheen. Verhuizen en niet klonen: zo blijven het
     canvas met de golf, het logo en de luisteraars op het formulier
     dezelfde. Vóór het vervagen aanroepen, want een element dat de pagina
     verlaat verliest zijn lopende overgangen. */
  var los = false;
  function maakLos() {
    if (los || !root.parentNode) return;
    los = true;
    ['boven', 'onder'].forEach(function (kant) {
      if (randen[kant] && randen[kant].parentNode) randen[kant].parentNode.removeChild(randen[kant]);
      randen[kant] = null;
    });
    var kopie = root.cloneNode(false);
    kopie.classList.add('is-los');
    /* even hoog als het vaste vlak, anders verspringt alles wat op een
       percentage van de hoogte staat (het logo in het midden) */
    kopie.style.height = root.getBoundingClientRect().height + 'px';
    while (root.firstChild) kopie.appendChild(root.firstChild);
    root.parentNode.replaceChild(kopie, root);
    root = kopie;
    void root.offsetWidth; /* eerst zo tekenen, dan pas vervagen */
  }

  var released = false;
  function release() {
    if (released) return;
    released = true;
    inerted.forEach(function (el) {
      el.inert = false;
    });
    inerted = [];
    try {
      document.dispatchEvent(new CustomEvent('klaasje:intro-leaving'));
    } catch (e) {}
  }

  var phase = 'gate'; // gate · loading · out
  var finished = false;

  function finish() {
    if (finished) return;
    finished = true;
    window.removeEventListener('resize', onResize);
    /* Al door iets anders weggehaald: dan is er niets meer van ons om op te
       ruimen, en mag de class op <html> niet weg (die kan van een nieuw vlak
       zijn). */
    if (!root.isConnected) return;
    try {
      sessionStorage.setItem(FLAG, '1');
    } catch (e) {}
    inerted.forEach(function (el) {
      el.inert = false;
    });
    html.classList.remove('klaasje-intro-open', 'klaasje-intro-leaving');
    if (root.parentNode) root.parentNode.removeChild(root);
    /* Vangnet: een toetsenbord op een telefoon kan de pagina eronder
       hebben laten schuiven. De site hoort bovenaan te openen. */
    scrollTopInstant();
    try {
      document.dispatchEvent(new CustomEvent('klaasje:intro-done'));
    } catch (e) {}
  }

  /* Meteen naar boven, ook als er ergens `scroll-behavior: smooth` staat. */
  function scrollTopInstant() {
    var active = document.activeElement;
    if (active && active.blur && root.contains(active)) {
      try {
        active.blur();
      } catch (e) {}
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }

  /* Hoe ver de hero is, van 0 tot 1 (1 = LEAD van de frames is binnen).
     Zonder hero op de pagina valt er niets te wachten. Is het element er
     wel maar nog niet opgewaardeerd (zijn script komt later), dan 0. */
  function heroProgress() {
    var hero = document.querySelector('klaasje-scroll-cinematic');
    if (!hero) return 1;
    if (typeof hero.framesAhead !== 'function') return 0;
    return LEAD > 0 ? Math.min(1, hero.framesAhead() / LEAD) : 1;
  }

  function clamp(value, min, max) {
    return value < min ? min : value > max ? max : value;
  }

  function smoothstep(a, b, x) {
    var t = clamp((x - a) / (b - a), 0, 1);
    return t * t * (3 - 2 * t);
  }

  /* ── 1. Het ribbon field ──────────────────────────────────────
     Per pixel: p is de plek langs de overgang (0 tot 1, zoals een
     CSS-verloop onder data-angle, van navy naar lichte navy), q de plek
     langs de linten (onder data-ribbon-angle). De linten verschuiven de
     overgang met wave * sin(q * frequency * 2π + phase); de overgang ligt op
     split en is softness breed naar elke kant. Daarover een vignet. De
     standaardwaarden zijn gefit op het voorbeeld van 21st.dev (zie het
     snippet).
     Twee keer getekend, met dezelfde rekensom: hier stilstaand op een
     2D-canvas (__ribbon), meteen na de eerste paint en als terugval, en in
     2 bewegend in WebGL (__wave), dat eroverheen invloeit. */

  var ribbon = root.querySelector('[data-klaasje-intro-ribbon]');

  function hexToRgb(value) {
    var hex = String(value || '').trim().replace('#', '');
    if (hex.length === 3) hex = hex.replace(/(.)/g, '$1$1');
    var n = parseInt(hex, 16);
    return isFinite(n) && hex.length === 6 ? [(n >> 16) & 255, (n >> 8) & 255, n & 255] : null;
  }

  /* De parameters van het snippet en de twee kleuren uit de fundering. */
  function ribbonParams() {
    var styles = getComputedStyle(root);
    var attr = function (name, fallback) {
      var value = ribbon ? parseFloat(ribbon.getAttribute('data-' + name)) : NaN;
      return isFinite(value) ? value : fallback;
    };
    return {
      light: hexToRgb(styles.getPropertyValue('--klaasje-navy-light')) || [67, 123, 157],
      dark: hexToRgb(styles.getPropertyValue('--klaasje-navy')) || [25, 61, 83],
      angle: (attr('angle', 132) * Math.PI) / 180,
      ribbonAngle: (attr('ribbon-angle', 19) * Math.PI) / 180,
      split: attr('split', 48.9) / 100,
      feather: attr('softness', 20.4) / 100,
      wave: attr('wave', 3.58) / 100,
      frequency: attr('frequency', 2.65),
      phase: attr('phase', 2.99),
      vignette: attr('vignette', 8) / 100,
    };
  }

  /* Stilstaand, op halve resolutie (het is één zacht verloop, de browser
     schaalt het glad op), met een fractie ruis tegen banding. */
  function drawRibbon() {
    if (!ribbon || !ribbon.getContext) return;
    var ctx = ribbon.getContext('2d');
    var cssW = ribbon.clientWidth;
    var cssH = ribbon.clientHeight;
    if (!ctx || !cssW || !cssH) return;
    var o = ribbonParams();

    var w = Math.max(1, Math.round(cssW * 0.5));
    var h = Math.max(1, Math.round(cssH * 0.5));
    ribbon.width = w;
    ribbon.height = h;
    var image = ctx.createImageData(w, h);
    var data = image.data;

    /* richtingen zoals bij een CSS-verloop: 0 graden is omhoog, met de klok
       mee; de lengte is die van de verlooplijn van CSS */
    var dx = Math.sin(o.angle);
    var dy = -Math.cos(o.angle);
    var length = Math.abs(w * dx) + Math.abs(h * dy);
    var ex = Math.sin(o.ribbonAngle);
    var ey = -Math.cos(o.ribbonAngle);
    var ribbonLength = Math.abs(w * ex) + Math.abs(h * ey);
    var halfDiagonal = Math.sqrt(w * w + h * h) / 2;
    var i = 0;
    for (var y = 0; y < h; y += 1) {
      var ry = y + 0.5 - h / 2;
      for (var x = 0; x < w; x += 1) {
        var rx = x + 0.5 - w / 2;
        var p = (rx * dx + ry * dy) / length + 0.5;
        var q = (rx * ex + ry * ey) / ribbonLength + 0.5;
        p += o.wave * WAVE_HEIGHT * Math.sin((q * o.frequency * 2 * Math.PI) / WAVE_LENGTH + o.phase);
        var t = smoothstep(o.split - o.feather, o.split + o.feather, p);
        var r = Math.sqrt(rx * rx + ry * ry) / halfDiagonal;
        var shade = 1 - o.vignette * smoothstep(0.52, 1, r);
        var noise = Math.random() - 0.5;
        data[i] = (o.dark[0] + (o.light[0] - o.dark[0]) * t) * shade + noise;
        data[i + 1] = (o.dark[1] + (o.light[1] - o.dark[1]) * t) * shade + noise;
        data[i + 2] = (o.dark[2] + (o.light[2] - o.dark[2]) * t) * shade + noise;
        data[i + 3] = 255;
        i += 4;
      }
    }
    ctx.putImageData(image, 0, 0);
    ribbon.classList.add('is-drawn');
  }

  var resizeTimer = 0;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      drawRibbon();
      sizeWave();
    }, 150);
  }

  /* ── 2. De golf ───────────────────────────────────────────────
     Dezelfde rekensom als drawRibbon, maar in een fragment-shader, zodat
     hij elke frame kan bewegen. Drie langzame bewegingen, met getallen die
     niet op elkaar deelbaar zijn, zodat het nooit zichtbaar in de pas loopt:
     - de S van de naad schuift langs de linten (de fase loopt op);
     - een tweede, langere en zwakkere golf loopt de andere kant op;
     - de uitslag ademt een fractie, en de naad zelf deint een paar procent
       heen en weer.
     Na enter gaat de golf van de ene stand naar de andere (zie de
     standaarden bovenin): de vorm (golflengte, hoogte, deinen, tempo) in
     SHAPE_MS, het licht in LIGHT_MS. Het licht is de diepte (navy dieper,
     de lichte kant helderder, voller van kleur, iets sterker vignet) en een
     kam net aan de lichte kant van de naad die licht vangt, over de hele
     lengte van de S en iets feller waar hij naar linksboven buigt, in de
     tint van de lichte navy en niet wit (anders worden de halve tinten
     grijs). De S is rond het midden geschreven, zodat een andere golflengte
     het midden laat staan.
     Alles in de kleuren en de vorm van het stilstaande verloop; bij t = 0
     is het vrijwel hetzelfde beeld, dus het invloeien valt niet op. Op
     halve resolutie: het is één zacht verloop, en zo kost het niets, ook
     niet op een oude telefoon. Zonder WebGL blijft het stilstaande verloop
     staan. */

  var wave = root.querySelector('[data-klaasje-intro-wave]');
  var gl = null;
  var waveUniforms = null;
  var waveRunning = false;
  var waveTime = 0;
  var waveRate = 0;
  var waveLast = 0;
  var baseFreq = 2.65;
  var baseAmp = 0.0358;

  var VERTEX = 'attribute vec2 aPos;varying vec2 vUv;void main(){vUv=vec2(aPos.x*0.5+0.5,0.5-aPos.y*0.5);gl_Position=vec4(aPos,0.0,1.0);}';
  var FRAGMENT = [
    'precision highp float;',
    'varying vec2 vUv;',
    'uniform vec2 uRes;',
    'uniform vec3 uDark;',
    'uniform vec3 uLight3;',
    'uniform vec2 uDir;',
    'uniform vec2 uRib;',
    'uniform vec3 uLen;',
    'uniform vec2 uShape;',
    'uniform float uCenter;',
    'uniform float uVignette;',
    'uniform float uFreq;',
    'uniform float uAmp;',
    'uniform float uSecond;',
    'uniform float uSway;',
    'uniform float uLight;',
    'uniform float uSheen;',
    'uniform float uDepth;',
    'uniform float uTime;',
    'void main(){',
    '  vec2 r=(vUv-0.5)*uRes;',
    '  float p=dot(r,uDir)/uLen.x+0.5;',
    '  float q=dot(r,uRib)/uLen.y+0.5;',
    '  float t=uTime;',
    /* de S, rond het midden geschreven: verandert de golflengte, dan blijft
       het midden staan. Schuift langs de linten en ademt een fractie. */
    '  float ph=(q-0.5)*uFreq*6.2832+uCenter+t*0.62;',
    '  p+=uAmp*(1.0+0.22*sin(t*0.41))*sin(ph);',
    /* een tweede, langere golf de andere kant op, die bij t = 0 nul is */
    '  p+=uAmp*uSecond*(sin(q*uFreq*2.7+1.9-t*0.37)-sin(q*uFreq*2.7+1.9))*min(t,1.0);',
    /* de naad deint heen en weer */
    '  float split=uShape.x+uSway*sin(t*0.29);',
    '  float x=p-split;',
    '  float m=smoothstep(-uShape.y,uShape.y,x);',
    '  float deep=uLight*uDepth;',
    /* diepte: navy dieper, de lichte kant helderder */
    '  vec3 col=mix(uDark*(1.0-0.12*deep),uLight3*(1.0+0.10*deep),m);',
    /* de kam vangt licht, iets feller waar de S naar linksboven buigt */
    '  float crest=exp(-pow((x-0.35*uShape.y)/(0.55*uShape.y),2.0));',
    '  col+=vec3(0.56,0.76,0.92)*crest*(0.75+0.25*cos(ph+0.8))*0.17*uLight*uSheen;',
    /* voller van kleur, zodat de halve tinten blauw blijven */
    '  col=mix(vec3(dot(col,vec3(0.299,0.587,0.114))),col,1.0+0.14*deep);',
    '  col*=1.0-(uVignette+0.06*deep)*smoothstep(0.52,1.0,length(r)/uLen.z);',
    /* een fractie ruis tegen banding */
    '  col+=(fract(52.9829189*fract(dot(gl_FragCoord.xy,vec2(0.06711056,0.00583715))))-0.5)/255.0;',
    '  gl_FragColor=vec4(col,1.0);',
    '}',
  ].join('\n');

  function compile(type, source) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(shader));
    return shader;
  }

  function initWave() {
    if (reduce || !wave || finished) return;
    try {
      gl = wave.getContext('webgl', { alpha: false, antialias: false, preserveDrawingBuffer: false });
      if (!gl) throw new Error('geen webgl');
      var program = gl.createProgram();
      gl.attachShader(program, compile(gl.VERTEX_SHADER, VERTEX));
      gl.attachShader(program, compile(gl.FRAGMENT_SHADER, FRAGMENT));
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error('link');
      gl.useProgram(program);
      var buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      var position = gl.getAttribLocation(program, 'aPos');
      gl.enableVertexAttribArray(position);
      gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
      var u = function (name) {
        return gl.getUniformLocation(program, name);
      };
      waveUniforms = {
        res: u('uRes'),
        dir: u('uDir'),
        rib: u('uRib'),
        len: u('uLen'),
        time: u('uTime'),
        freq: u('uFreq'),
        amp: u('uAmp'),
        second: u('uSecond'),
        sway: u('uSway'),
        light: u('uLight'),
      };
      var o = ribbonParams();
      baseFreq = o.frequency;
      baseAmp = o.wave;
      gl.uniform3f(u('uDark'), o.dark[0] / 255, o.dark[1] / 255, o.dark[2] / 255);
      gl.uniform3f(u('uLight3'), o.light[0] / 255, o.light[1] / 255, o.light[2] / 255);
      gl.uniform2f(u('uShape'), o.split, o.feather);
      /* de fase in het midden, gelijk aan die van de stilstaande tekening */
      gl.uniform1f(u('uCenter'), o.phase + (Math.PI * o.frequency) / WAVE_LENGTH);
      gl.uniform1f(u('uVignette'), o.vignette);
      gl.uniform1f(u('uSheen'), SHEEN);
      gl.uniform1f(u('uDepth'), DEPTH);
      sizeWave();
      root.classList.add('is-waving');
      startWave();
    } catch (error) {
      gl = null;
    }
  }

  /* Canvas op halve resolutie; de richtingen en lengtes zoals in drawRibbon,
     maar in CSS-pixels (de verhoudingen zijn dezelfde). */
  function sizeWave() {
    if (!gl) return;
    var width = wave.clientWidth;
    var height = wave.clientHeight;
    if (!width || !height) return;
    wave.width = Math.max(1, Math.round(width * 0.5));
    wave.height = Math.max(1, Math.round(height * 0.5));
    gl.viewport(0, 0, wave.width, wave.height);
    var o = ribbonParams();
    var dx = Math.sin(o.angle);
    var dy = -Math.cos(o.angle);
    var ex = Math.sin(o.ribbonAngle);
    var ey = -Math.cos(o.ribbonAngle);
    gl.uniform2f(waveUniforms.res, width, height);
    gl.uniform2f(waveUniforms.dir, dx, dy);
    gl.uniform2f(waveUniforms.rib, ex, ey);
    gl.uniform3f(
      waveUniforms.len,
      Math.abs(width * dx) + Math.abs(height * dy),
      Math.abs(width * ex) + Math.abs(height * ey),
      Math.sqrt(width * width + height * height) / 2
    );
    drawWave();
  }

  /* Na enter, een zachte ease-in-out van 0 (de gate) naar 1 (na enter). */
  function easeInOut(e) {
    e = clamp(e, 0, 1);
    return e < 0.5 ? 4 * e * e * e : 1 - Math.pow(-2 * e + 2, 3) / 2;
  }

  function afterEnter(ms) {
    return submittedAt ? easeInOut((performance.now() - submittedAt) / ms) : 0;
  }

  function mix(a, b, k) {
    return a + (b - a) * k;
  }

  /* De vorm tussen de twee standen in. De golflengte gaat via zijn lengte en
     niet via de frequentie, zodat hij gelijkmatig verandert. De tweede golf
     neemt na enter af tot de helft, zodat een hogere golf minder snel vouwt. */
  function drawWave() {
    var k = afterEnter(SHAPE_MS);
    gl.uniform1f(waveUniforms.time, waveTime);
    gl.uniform1f(waveUniforms.freq, baseFreq / mix(WAVE_LENGTH, SWELL_LENGTH, k));
    gl.uniform1f(waveUniforms.amp, baseAmp * mix(WAVE_HEIGHT, SWELL_HEIGHT, k));
    gl.uniform1f(waveUniforms.second, mix(0.38, 0.19, k));
    gl.uniform1f(waveUniforms.sway, mix(WAVE_SWAY, SWELL_SWAY, k) / 100);
    gl.uniform1f(waveUniforms.light, afterEnter(LIGHT_MS));
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  }

  /* De tijd loopt met waveRate mee, zodat de golf rustig op gang komt in
     plaats van ineens te bewegen: na het invloeien, of bij
     data-wave-from="enter" pas na enter. */
  function tickWave(now) {
    if (!waveRunning || finished || !root.isConnected) return;
    var dt = waveLast ? Math.min(0.1, (now - waveLast) / 1000) : 0;
    waveLast = now;
    var target = WAVE_FROM_ENTER && phase === 'gate' ? 0 : 1;
    waveRate += (target - waveRate) * Math.min(1, dt * 1.5);
    waveTime += dt * waveRate * mix(WAVE_SPEED, SWELL_SPEED, afterEnter(SHAPE_MS));
    try {
      drawWave();
    } catch (e) {
      waveRunning = false;
      return;
    }
    requestAnimationFrame(tickWave);
  }

  function startWave() {
    if (!gl || waveRunning) return;
    waveRunning = true;
    waveLast = 0;
    requestAnimationFrame(tickWave);
  }

  /* ── 3. De kleurwissel ──────────────────────────────────────
     Zoals live: het logo springt rood, groen, geel, in harde stappen. Aan
     het eind van elke ronde staat het geel. Is de hero dan zover (of het
     plafond om), dan blijft het geel staan tot FADE_AT_MS na enter en
     vervaagt het vlak; zo niet, dan nog een ronde. Zo eindigt het altijd op
     geel. Vanuit JS en niet als CSS-animatie, zodat het vervagen precies op
     dat geel valt. */

  var deadline = 0;
  var submittedAt = 0;

  function loaded(now) {
    return now >= deadline || heroProgress() >= 1;
  }

  function brandColors() {
    var styles = getComputedStyle(root);
    return ['--klaasje-red', '--klaasje-green', '--klaasje-yellow'].map(function (name, i) {
      return styles.getPropertyValue(name).trim() || ['#db3b4b', '#6fbf5a', '#ffd243'][i];
    });
  }

  function startColors() {
    if (finished || phase !== 'loading') return;
    var colors = brandColors();
    root.classList.add('is-coloring');
    function round() {
      if (finished || phase !== 'loading') return;
      colors.forEach(function (color, i) {
        setTimeout(function () {
          if (phase === 'loading') logoEl.style.color = color;
        }, i * COLOR_STEP_MS);
      });
      setTimeout(check, colors.length * COLOR_STEP_MS);
    }
    function check() {
      if (finished || phase !== 'loading') return;
      var now = performance.now();
      var early = submittedAt + FADE_AT_MS - now;
      if (!loaded(now)) round();
      else if (early > 0) setTimeout(check, early);
      else fadeOut();
    }
    round();
  }

  /* ── 4. Vervagen ───────────────────────────────────────────── */

  /* Het header-logo dat nu te zien is, of null. Alleen een inline SVG: een
     zelf geüpload logo (een <img>) heeft een eigen tekening en kleur, en
     daar is landen niet mooi te krijgen. */
  function headerLogo() {
    var candidates = document.querySelectorAll('.klaasje-header__logo svg');
    for (var i = 0; i < candidates.length; i += 1) {
      var el = candidates[i];
      var rect = el.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0 && parseFloat(getComputedStyle(el).opacity) > 0.5) return el;
    }
    return null;
  }

  /* Het vlak vervaagt in FADE_MS (de duur zet de JS, zodat data-fade-ms
     werkt). Het logo glijdt intussen in zijn plek in de header en neemt
     halverwege, als de site er al half doorheen staat, de kleur van het
     header-logo aan. Daarna ligt het precies op het echte logo en mag het
     weg. */
  function fadeOut() {
    if (finished || phase !== 'loading') return;
    phase = 'out';
    scrollTopInstant();
    /* de kleur mag weer overvloeien, naar die van het header-logo */
    root.classList.remove('is-coloring');

    var target = FLIGHT ? headerLogo() : null;
    var landColor = '';
    if (target) {
      var from = logoEl.getBoundingClientRect();
      var to = target.getBoundingClientRect();
      var scale = to.height / from.height;
      var dx = to.left + to.width / 2 - (from.left + from.width / 2);
      var dy = to.top + to.height / 2 - (from.top + from.height / 2);
      landColor = getComputedStyle(target).color;
      root.classList.add('is-flying');
      logoEl.style.transform =
        'translate(' + dx.toFixed(1) + 'px, ' + dy.toFixed(1) + 'px) scale(' + scale.toFixed(4) + ')';
    }

    sheet.style.transitionDuration = FADE_MS + 'ms';
    html.classList.add('klaasje-intro-leaving');
    maakLos();
    release();
    root.classList.add('is-out');
    setTimeout(function () {
      if (landColor) logoEl.style.color = landColor;
    }, FADE_MS / 2);
    setTimeout(function () {
      if (target) {
        root.classList.add('is-landed');
        setTimeout(finish, 170);
      } else {
        finish();
      }
    }, FADE_MS);
  }

  /* ── Formulier ─────────────────────────────────────────────── */

  /* Alleen cijfers, en door naar het volgende veld als dit vol is */
  function wire(el, next) {
    el.addEventListener('input', function () {
      el.value = el.value.replace(/\D/g, '');
      if (next && el.value.length >= el.maxLength) next.focus();
    });
  }
  wire(dayEl, monthEl);
  wire(monthEl, yearEl);
  wire(yearEl, null);

  window.addEventListener('resize', onResize, { passive: true });
  /* na de eerste paint, zodat de gate niet op de tekening wacht; de golf
     een frame later, zodat ook het compileren de gate niet ophoudt */
  requestAnimationFrame(function () {
    try {
      drawRibbon();
    } catch (e) {}
    setTimeout(initWave, 60);
  });

  /* Loopt de lanceringsklok nog (klaasje-countdown), dan staan de velden
     verborgen; de focus komt pas als de klok weg is. */
  function focusDay() {
    try {
      dayEl.focus();
    } catch (e) {}
  }
  if (html.classList.contains('klaasje-klok-open')) {
    document.addEventListener('klaasje:klok-klaar', function () {
      setTimeout(focusDay, 650);
    });
  } else {
    setTimeout(focusDay, reduce ? 0 : 450);
  }

  function isAdult() {
    var d = parseInt(dayEl.value, 10);
    var m = parseInt(monthEl.value, 10);
    var y = parseInt(yearEl.value, 10);
    if (!d || !m || !y || yearEl.value.length < 4) return false;
    if (m < 1 || m > 12 || d < 1 || d > 31 || y < 1900) return false;
    var birth = new Date(y, m - 1, d);
    /* niet-bestaande datums, bijvoorbeeld 31 februari */
    if (birth.getFullYear() !== y || birth.getMonth() !== m - 1 || birth.getDate() !== d) return false;
    var now = new Date();
    if (birth > now) return false;
    var age = now.getFullYear() - y;
    if (now.getMonth() < m - 1 || (now.getMonth() === m - 1 && now.getDate() < d)) age--;
    return age >= 18;
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (phase !== 'gate') return;

    if (!isAdult()) {
      errorEl.textContent = 'Je moet 18 jaar of ouder zijn om deze website te bezoeken.';
      errorEl.classList.add('is-visible');
      fields.classList.remove('is-shaking');
      void fields.offsetWidth; /* reflow, zodat de schud bij elke poging opnieuw speelt */
      fields.classList.add('is-shaking');
      try {
        dayEl.focus();
        dayEl.select();
      } catch (e) {}
      return;
    }
    errorEl.classList.remove('is-visible');

    /* Minder beweging: geen kleurwissel en geen vlucht. Het scherm vervaagt
       en de site staat er. */
    if (reduce) {
      phase = 'out';
      html.classList.add('klaasje-intro-leaving');
      maakLos();
      release();
      root.classList.add('is-fading');
      setTimeout(finish, 400);
      return;
    }

    submittedAt = performance.now();
    phase = 'loading';
    deadline = submittedAt + MAX_WAIT_MS;
    /* Vangnet: wat er ook gebeurt, ná het plafond, een kleurronde en het
       vervagen is het vlak weg. */
    setTimeout(finish, Math.max(MAX_WAIT_MS, FADE_AT_MS) + 3 * COLOR_STEP_MS + FADE_MS + 1500);

    /* Nu het vlak nog alles dekt alvast naar boven, zodat de site straks
       bovenaan verschijnt in plaats van zichtbaar terug te scrollen. */
    scrollTopInstant();
    root.classList.add('is-submitting');
    startWave();
    setTimeout(startColors, COLOR_AT_MS);
  });
})();
